const useUrlIframeBankIds = ["1011", "855"];

const emailRequiredBankIds = ["855", "856"];

const useNewTabWithIframeBankIds = ["914"];

const useNewWindowPaymentBankIds = ["1016"];

const multipleCommissionAddBankIds = [
  836, 845, 849, 896, 1015, 864, 891, 890, 889, 926, 892, 855, 925, 865, 922,
  914, 889, 890, 856, 857,
];

const validateLuhn = (cardNumber) => {
  const sanitized = cardNumber.replace(/\D/g, "");
  let sum = 0;
  let shouldDouble = false;

  for (let i = sanitized.length - 1; i >= 0; i--) {
    let digit = parseInt(sanitized.charAt(i), 10);

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
};

const openCenteredPopup = (url) => {
  const width = 600;
  const height = 600;

  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`;

  const newWindow = window.open(url, "_blank", features);

  if (!newWindow) {
    alert(
      "Yeni pencere açılamadı. Lütfen tarayıcı ayarlarınızdan açılır pencere (popup) engellemesini devre dışı bırakın."
    );
  }
};

export {
  useUrlIframeBankIds,
  emailRequiredBankIds,
  validateLuhn,
  useNewTabWithIframeBankIds,
  useNewWindowPaymentBankIds,
  openCenteredPopup,
  multipleCommissionAddBankIds
};
